







































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { BeforeInstallPromptEvent, VuePwaInstallMixin } from "vue-pwa-install";

@Component({
  mixins: [VuePwaInstallMixin],
  name: "App",
})
export default class Home extends Vue {
  showPWAInstallBanner = false;
  registration: ServiceWorkerRegistration | null = null;
  updateExists = false;
  refreshing = false;

  @Action("language/refreshLanguages") refreshLanguages?: () => void;

  @Getter("language/language") language?: string;
  @Getter("pwaInstallEvent") deferredPrompt:
    | BeforeInstallPromptEvent
    | undefined
    | null;
  @Action("setPwaInstallEvent") setPwaInstallEvent: any;
  @Action("language/setLanguage") setLanguage?: (lang: string) => void;
  @Watch("language")
  languageChanged(val: string, old: string) {
    if (val && val !== old) {
      this.$vuetify.lang.current = val.split("-")[0];
    }
  }

  @Getter("isDarkTheme") isDarkTheme?: boolean;
  @Watch("isDarkTheme") ThemeChanged(val: boolean) {
    this.$vuetify.theme.dark = val;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  async created() {
    if (this.refreshLanguages){
      this.refreshLanguages();
    }

    this.$on("canInstall", (event: BeforeInstallPromptEvent) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt:
      event.preventDefault();

      // Stash the event so it can be triggered later:
      this.setPwaInstallEvent(event);

      if (
        this.$cookies.get("pwa-dismiss") !== undefined &&
        this.$cookies.get("pwa-dismiss") !== null
      ) {
        this.showPWAInstallBanner = false;
        return;
      }

      //show only for mobile
      if (this.isMobile) {
        this.showPWAInstallBanner = true;
      }
    });

    this.promptInstall();

    //event listener for service worker update (new version of app is detected) - emitted in registerServiceWorker.ts
    document.addEventListener(
      "swUpdated",
      this.updateAvailable as EventListener,
      { once: true }
    );

    this.$vuetify.theme.dark = this.isDarkTheme || false;

    await this.$store.dispatch("language/getTextResource");
    this.$vuetify.lang.current =
      this.$store.getters["language/language"].split("-")[0];

    //actual refresh functionality - happens after we've told the new service worker to skip waiting and become active, emits controllerchange event.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });

    if (this.language && this.setLanguage) {
      this.setLanguage(this.language);
    }
  }

  mounted() {
    if (this.refreshButtonDisabled) {
      if (!this.refreshButtonDisabledTimer) this.refreshButtonDisabled = false;
      else {
        setTimeout(() => {
          this.refreshButtonDisabled = false;
        }, this.refreshButtonDisabledTimer * 1000);
      }
    }
  }

  get displayPWAInstallPopup() {
    return this.showPWAInstallBanner && this.deferredPrompt;
  }

  get displayNewVersionPopup() {
    return this.updateExists && !this.displayPWAInstallPopup;
  }

  updateAvailable(event: SWRCustomEvent) {
    this.registration = event.detail;
    this.updateExists = true;
  }

  refreshApp() {
    this.updateExists = false;
    if (!this.registration || !this.registration.waiting) return;

    this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
  }

  dismissRefresh() {
    this.updateExists = false;
  }

  promptInstall() {
    // Show the prompt:
    // Wait for the user to respond to the prompt:
    this.deferredPrompt?.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        this.showPWAInstallBanner = false;
      } else {
        this.showPWAInstallBanner = false;
      }
      this.setPwaInstallEvent(null);
    });
  }

  async dismissInstall() {
    this.$cookies.set("pwa-dismiss", "dismissed", { expires: "15d" });

    this.showPWAInstallBanner = false;
  }

  async install() {
    this.deferredPrompt?.prompt();
  }

  // when removing this message just remove the text and set the timer to 0, everything else can remain in case we ever need to write another update message
  refreshButtonDisabled = true;
  refreshButtonDisabledTimer = 0; // in seconds
  get updateInfoMessage() {
    //switch (this.language) {
    //  case "hr-HR":
    //    return `Ova verzija donosi značajna poboljšanja vezana uz evidenciju plaćanja predujmovnih politika. Promjene možete vidjeti u <a target="_blank" href="https://nokumo-app.zendesk.com/hc/hr-hr/articles/18583269053340-VA%C5%BDNE-IZMJENE-Pla%C4%87anja-i-predujmovne-politike">dokumentaciji predujmovnih politika</a>. Za sva ostala pitanja, molimo Vas da nas kontaktirate na <a href="mailto:support@nokumo.net">support@nokumo.net</a>.`;
    //  case "en-GB":
    //    return `This version features noteworthy improvements to the workflow surrounding the handling of prepayment policies. To learn more about the changes, please visit <a target="_blank" href="https://nokumo-app.zendesk.com/hc/hr-hr/articles/18583269053340-VA%C5%BDNE-IZMJENE-Pla%C4%87anja-i-predujmovne-politike">the prepayment policies documentation</a>. For any additional questions, please contact us at <a href="mailto:support@nokumo.net">support@nokumo.net</a>.`;
    //  case "sl-SI":
    //    return `Ta različica prinaša pomembne izboljšave v zvezi z evidenco plačil politike predplačil. Spremembe si lahko ogledate v <a target="_blank" href="https://nokumo-app.zendesk.com/hc/hr-hr/articles/18583269053340-VA%C5%BDNE-IZMJENE-Pla%C4%87anja-i-predujmovne-politike">dokumentaciji politike predplačil</a>. Za vsa dodatna vprašanja nas prosimo kontaktirajte na <a href="mailto:support@nokumo.net">support@nokumo.net</a>.`;
    //}

    return "";
  }
}

interface SWRCustomEvent extends Event {
  detail: ServiceWorkerRegistration;
}
